<template>
  <div class="media-gallery">
    <MediaGalleryGrid
      v-bind="$attrs"
      v-if="layout === 'grid'"
      :featureImages="featureImages"
      :videoUrl="videoUrl"
      :desktopLimit="desktop"
      :mobileLimit="mobile"
    >
      <template #manage-photos>
        <slot name="manage-photos" />
      </template>
    </MediaGalleryGrid>
    <MediaGalleryFlex v-bind="$attrs" v-else :layout="layout" :featureImages="featureImages" />
  </div>
</template>

<script setup>
import '@/plugins/fslightbox.js'
import MediaGalleryFlex from './MediaGalleryFlex.vue'
import MediaGalleryGrid from './MediaGalleryGrid.vue'
import { useBodyClass } from '@/helpers/vueHelpers.js'

defineProps({
  featureImages: Array,
  videoUrl: String,
  layout: {
    type: String,
    default: 'grid',
  },
  desktop: {
    type: Number,
    default: 5,
  },
  mobile: {
    type: Number,
    default: 6,
  },
})

useBodyClass('has-media-gallery')
</script>

<style lang="scss" scoped>
:deep(.image-overlay),
:deep(.itinerary-gallery__image-overlay) {
  font-size: 30px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: $black;
  font-weight: $font-semibold;
  background-color: rgba($white, 0.55);

  &::after {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    content: attr(data-more-images);
  }

  @include mobile {
    font-size: 20px;
  }
}
</style>

<style lang="scss">
.lightbox-image-caption {
  color: $white;
}

.lightbox-image-caption:hover {
  color: $white;
  text-decoration: underline;
}
</style>

<style lang="scss">
.has-media-gallery img.fslightboxs {
  border-radius: 15px;
}
</style>
